import { put, call } from 'redux-saga/effects';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { BACKEND_URL } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';
import { OK } from '../../../configs/serverStatusCodes';
import {
  loadSubscriptionByIdFailed,
  loadSubscriptionByIdSuccessful,
} from '../actions';

export default function* loadSubscriptionById(action) {
  try {
    const id = action.payload;

    const url = `${BACKEND_URL}/proxy/subscription/v1/subscriptions/${id}`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadSubscriptionByIdSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(loadSubscriptionByIdFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadSubscriptionByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
